import React, { useState } from 'react';
import { Check, X, Lock, ShieldCheck, Zap, Mail, Smartphone, Briefcase } from 'lucide-react';
const COMBOS = [{
  id: 2,
  name: 'PACK COMPLETO',
  badge: '⭐ MÁS VENDIDO',
  subtitle: 'El sistema + bonos + libro exclusivo',
  originalPrice: '$69.990',
  discount: '57% OFF',
  price: '$29.990',
  url: 'https://checkout12.rosetadigital.com/cart/50986135814450:1',
  tomos: ['Tomo 01 — La Entrada de Impacto', 'Tomo 02 — El Lenguaje del Dinero', 'Tomo 03 — El Espejo del Líder', 'Tomo 04 — Neutralizador de Críticos', 'Tomo 05 — Oratoria No Verbal', 'Tomo 06 — De Reemplazable a Clave'],
  bonuses: ['Presencia Ejecutiva en 15 Min', 'El Mapa de Reuniones', 'Entrevista Impecable', 'Manual Anti-Nervios', 'Kit de Follow-Up Profesional', 'Tracker de Ascenso 90 Días'],
  exclusiveBook: {
    title: 'El Maletín Ejecutivo',
    subtitle: 'Scripts y Protocolos de Emergencia'
  },
  extras: ['+360 páginas', 'Entrega inmediata por email, en formato PDF']
}, {
  id: 1,
  name: 'PACK ESENCIAL',
  subtitle: 'El sistema completo para empezar',
  originalPrice: '$49.990',
  discount: '60% OFF',
  price: '$19.990',
  url: 'https://checkout12.rosetadigital.com/cart/50986133487922:1',
  tomos: ['Tomo 01 — La Entrada de Impacto', 'Tomo 02 — El Lenguaje del Dinero', 'Tomo 03 — El Espejo del Líder', 'Tomo 04 — Neutralizador de Críticos', 'Tomo 05 — Oratoria No Verbal', 'Tomo 06 — De Reemplazable a Clave'],
  bonuses: ['Presencia Ejecutiva en 15 Min', 'El Mapa de Reuniones', 'Entrevista Impecable', 'Manual Anti-Nervios', 'Kit de Follow-Up Profesional', 'Tracker de Ascenso 90 Días'],
  extras: ['+360 páginas', 'Entrega inmediata por email, en formato PDF'],
  excluded: ['Sin El Maletín Ejecutivo']
}];
export function CheckoutSection() {
  const [selectedId, setSelectedId] = useState(2);
  const selectedCombo = COMBOS.find(c => c.id === selectedId)!;
  const otherCombo = COMBOS.find(c => c.id !== selectedId)!;
  const renderComboCard = (combo: (typeof COMBOS)[number], isSelected: boolean) => {
    const isHighlighted = combo.id === 2;
    return <div key={combo.id} onClick={() => setSelectedId(combo.id)} className={`
          relative rounded-lg border-2 cursor-pointer transition-all duration-300 overflow-hidden
          ${isSelected ? isHighlighted ? 'border-brand-gold bg-[#1F1A0F] glow-gold-strong' : 'border-brand-gold bg-[#1A1A1A]' : 'border-brand-dark bg-brand-black hover:border-brand-gold/50'}
        `} data-id="element-42">
        {combo.badge && <div className={`absolute top-0 right-0 px-2 py-0.5 text-[10px] font-bold rounded-bl-lg ${isHighlighted ? 'bg-brand-gold text-brand-black' : 'bg-brand-dark text-brand-gold border-b border-l border-brand-gold'}`} data-id="element-43">
            {combo.badge}
          </div>}

        <div className="p-3" data-id="element-44">
          <div className="flex items-start" data-id="element-45">
            <div className="mt-0.5 mr-2.5 flex-shrink-0" data-id="element-46">
              <div className={`w-4 h-4 rounded-full border-2 flex items-center justify-center ${isSelected ? 'border-brand-gold' : 'border-brand-muted'}`} data-id="element-47">
                {isSelected && <div className="w-2 h-2 rounded-full bg-brand-gold" data-id="element-48" />}
              </div>
            </div>

            <div className="flex-grow min-w-0" data-id="element-49">
              <div className="flex items-center justify-between" data-id="element-50">
                <div data-id="element-51">
                  <h3 className={`text-base font-bold leading-tight ${isSelected ? 'text-brand-gold' : 'text-brand-text'}`} data-id="element-52">
                    {combo.name}
                  </h3>
                  <p className="text-brand-muted text-[10px]" data-id="element-53">
                    {combo.subtitle}
                  </p>
                </div>
                <div className="text-right flex-shrink-0 ml-3" data-id="element-54">
                  <div className="flex items-center justify-end gap-1.5" data-id="element-55">
                    <span className="text-brand-muted line-through text-[10px]" data-id="element-56">
                      {combo.originalPrice}
                    </span>
                    <span className="bg-brand-green/20 text-brand-green text-[9px] font-bold px-1 py-0.5 rounded" data-id="element-57">
                      {combo.discount}
                    </span>
                  </div>
                  <div className="text-lg font-bold text-brand-text leading-tight" data-id="element-58">
                    {combo.price}{' '}
                    <span className="text-[10px] font-normal text-brand-muted" data-id="element-59">
                      ARS
                    </span>
                  </div>
                </div>
              </div>

              {isSelected && <div className="pt-2 mt-2 border-t border-brand-gold/20 animate-fade-in" data-id="element-60">
                  {/* Tomos - 2 columns */}
                  <div className="grid grid-cols-2 gap-x-2 gap-y-0.5 mb-2" data-id="element-61">
                    {combo.tomos.map((tomo, idx) => <div key={idx} className="flex items-start text-[11px]" data-id="element-62">
                        <Check className="text-brand-gold mr-1 flex-shrink-0 mt-0.5" size={11} data-id="element-63" />
                        <span className="text-brand-text leading-tight" data-id="element-64">
                          {tomo}
                        </span>
                      </div>)}
                  </div>

                  {/* Exclusive Book */}
                  {combo.exclusiveBook && <div className="text-[11px] mb-2 bg-cyan-500/10 border border-cyan-500/30 rounded px-2 py-1.5" data-id="element-65">
                      <div className="flex items-start" data-id="element-66">
                        <Briefcase className="text-cyan-400 mr-1 flex-shrink-0 mt-0.5" size={12} data-id="element-67" />
                        <div data-id="element-68">
                          <span className="text-cyan-400 font-bold" data-id="element-69">
                            EXCLUSIVO — {combo.exclusiveBook.title}
                          </span>
                          <span className="text-cyan-300/80 ml-1" data-id="element-70">
                            · {combo.exclusiveBook.subtitle}
                          </span>
                        </div>
                      </div>
                      <p className="text-cyan-300/70 mt-1 ml-4 leading-snug" data-id="element-71">
                        Frases exactas, respuestas listas y protocolos paso a
                        paso para resolver cualquier situación laboral difícil
                        en el momento.
                      </p>
                    </div>}

                  {/* Bonuses - 2 columns */}
                  {combo.bonuses.length > 0 && <div className="grid grid-cols-2 gap-x-2 gap-y-0.5 mb-2" data-id="element-72">
                      {combo.bonuses.map((bonus, idx) => <div key={idx} className="flex items-center text-[11px]" data-id="element-73">
                          <Check className="text-brand-gold mr-1 flex-shrink-0" size={11} data-id="element-74" />
                          <span className="text-brand-text leading-tight" data-id="element-75">
                            Bono {idx + 1} — {bonus}
                          </span>
                          <span className="text-brand-green text-[8px] font-bold ml-0.5 flex-shrink-0 bg-brand-green/10 px-0.5 rounded" data-id="element-76">
                            GRATIS
                          </span>
                        </div>)}
                    </div>}

                  {/* Extras */}
                  <div className="flex flex-wrap gap-x-3 gap-y-0.5" data-id="element-77">
                    {combo.extras.map((extra, idx) => <div key={idx} className="flex items-center text-[11px]" data-id="element-78">
                        <Check className="text-brand-gold mr-1 flex-shrink-0" size={11} data-id="element-79" />
                        <span className="text-brand-text" data-id="element-80">{extra}</span>
                      </div>)}
                  </div>

                  {/* Excluded */}
                  {combo.excluded && combo.excluded.map((item, idx) => <div key={idx} className="flex items-center text-[11px] mt-0.5" data-id="element-81">
                        <X className="text-brand-red/70 mr-1 flex-shrink-0" size={11} data-id="element-82" />
                        <span className="text-brand-muted line-through" data-id="element-83">
                          {item}
                        </span>
                      </div>)}
                </div>}
            </div>
          </div>
        </div>
      </div>;
  };
  return <section id="checkout" className="py-8 px-3 bg-brand-black relative" data-id="element-84">
      <div className="max-w-3xl mx-auto" data-id="element-85">
        <div className="text-center mb-5" data-id="element-86">
          <h2 className="font-heading text-xl md:text-4xl font-bold text-brand-text mb-1" data-id="element-87">
            Elegí Tu Nivel de Acceso
          </h2>
          <p className="text-brand-muted text-sm mb-2" data-id="element-88">
            Una sola inversión. Acceso inmediato. Tuyo para siempre.
          </p>
          <div className="inline-flex items-center text-brand-red font-bold animate-pulse text-[10px] bg-brand-red/10 px-2.5 py-1 rounded-full" data-id="element-89">
            🔴 Solo quedan 17 accesos al precio de lanzamiento
          </div>
        </div>

        {/* Both packs together */}
        <div className="space-y-2 mb-4" data-id="element-90">
          {renderComboCard(selectedCombo, true)}
          {renderComboCard(otherCombo, false)}
        </div>

        {/* Price + CTA */}
        <div className="text-center" data-id="element-91">
          <div className="mb-2" data-id="element-92">
            <span className="text-brand-muted line-through text-sm mr-1.5" data-id="element-93">
              {selectedCombo.originalPrice}
            </span>
            <span className="text-2xl font-bold text-brand-text" data-id="element-94">
              {selectedCombo.price}
            </span>
            <span className="text-brand-muted text-xs ml-1" data-id="element-95">ARS</span>
          </div>

          <a href={selectedCombo.url} onClick={() => {
          if (window.fbq) {
            window.fbq('track', 'InitiateCheckout', {
              content_name: selectedCombo.name,
              content_ids: [String(selectedCombo.id)],
              value: parseFloat(selectedCombo.price.replace(/[^0-9.]/g, '')),
              currency: 'ARS'
            });
          }
        }} className="block w-full py-3 px-6 bg-brand-gold hover:bg-brand-gold-light text-brand-black font-bold text-base rounded-xl transition-all transform hover:scale-[1.02] animate-pulse-gold shadow-2xl mb-3" data-id="element-96">
            <span className="flex items-center justify-center" data-id="element-97">
              <Lock className="mr-2" size={18} data-id="element-98" />
              COMPRAR AHORA — ACCESO INMEDIATO
            </span>
          </a>

          <div className="flex flex-wrap justify-center items-center gap-2 text-brand-muted text-[10px] font-medium" data-id="element-99">
            <div className="flex items-center" data-id="element-100">
              <ShieldCheck size={12} className="mr-0.5 text-brand-gold" data-id="element-101" /> Pago
              Seguro
            </div>
            <div className="flex items-center" data-id="element-102">
              <Zap size={12} className="mr-0.5 text-brand-gold" data-id="element-103" /> Entrega
              Inmediata
            </div>
            <div className="flex items-center" data-id="element-104">
              <Mail size={12} className="mr-0.5 text-brand-gold" data-id="element-105" /> PDF por
              email
            </div>
            <div className="flex items-center" data-id="element-106">
              <Smartphone size={12} className="mr-0.5 text-brand-gold" data-id="element-107" />{' '}
              Multidispositivo
            </div>
          </div>
        </div>
      </div>
    </section>;
}